const possibleConfigurations = {
  // eslint-disable-next-line no-template-curly-in-string
  '${usuario.Usuario.iut}': 'Rut',
  // eslint-disable-next-line no-template-curly-in-string
  '${usuario.Usuario.nombre}': 'Nombre',
  // eslint-disable-next-line no-template-curly-in-string
  '${usuario.Usuario.cargo}': 'Cargo',
  // eslint-disable-next-line no-template-curly-in-string
  '${usuario.Usuario.departamento}': 'Departamento',
  // eslint-disable-next-line no-template-curly-in-string
  '${empresa.Empresa.razonSocial}': 'Razón social',
  // eslint-disable-next-line no-template-curly-in-string
  '${empresa.Empresa.fantasia}': 'Fantasia',
  // eslint-disable-next-line no-template-curly-in-string
  '${empresa.Empresa.iut}': 'Rut Empresa'
};

const configType = {
  onlyText: '1',
  draw: '2',
  atached: '3',
  desing: '4'
};

const ambits = {
  managedment: 'unidad',
  profile: 'perfil'
};

const configutationsIds = {
  respresentation: 'io.febos.firma.sagile.representacion',
  template: 'io.febos.firma.sagile.plantilla',
  background: 'io.febos.firma.sagile.background',
  emulation: 'io.febos.firma.sagile.emulacion',
};
const certStatus = {
  CREATE: 'P',
  ACTIVE: 'A',
  EXPIRED: 'E',
  INACTIVE: 'N',
};
const proveedor = 'SAgile';

const Configuration = class Configuration {
  constructor(type, size, color, font, x, y, ay, ax, content) {
    this.type = type;
    this.size = size;
    this.color = color;
    this.font = font;
    this.x = x;
    this.y = y;
    this.ay = ay;
    this.ax = ax;
    this.content = content;
  }

  static parseText(configuration) {
    const configurations = configuration.split('||||')[0].split(';');
    let type = 'T'; let size; let color; let font; let x; let y; let ay; let ax; const
      content = configuration.split('||||')[1];
    for (let index = 0; index < configurations.length; index += 1) {
      const config = configurations[index].split('=')[0];
      const value = configurations[index].split('=')[1];
      switch (config) {
        case 'S': {
          size = value;
          break;
        }
        case 'C': {
          color = value;
          break;
        }
        case 'T': {
          type = value;
          break;
        }
        case 'F': {
          font = value;
          break;
        }
        case 'X': {
          x = value;
          break;
        }
        case 'Y': {
          y = value;
          break;
        }
        case 'AX': {
          ax = value;
          break;
        }
        case 'AY': {
          ay = value;
          break;
        }
        default: {
          console.log('default');
        }
      }
    }
    return new Configuration(type, size, color, font, x, y, ay, ax, content);
  }

  static toText(configuration) {
    const configs = [];
    const content = [];
    const keys = Object.entries(configuration);
    keys.forEach(([key, value]) => {
      if (key === 'content') {
        content.push(value);
      } else {
        switch (key) {
          case 'type': {
            configs.push(`T=${value || ''}`);
            break;
          }
          case 'size': {
            configs.push(`S=${value || ''}`);
            break;
          }
          case 'color': {
            configs.push(`C=${value || ''}`);
            break;
          }
          case 'font': {
            configs.push(`F=${value || ''}`);
            break;
          }
          case 'x': {
            configs.push(`X=${value || '0'}`);
            break;
          }
          case 'y': {
            configs.push(`Y=${value || '0'}`);
            break;
          }
          case 'ax': {
            configs.push(`AX=${value || '0'}`);
            break;
          }
          case 'ay': {
            configs.push(`ay=${value || '0'}`);
            break;
          }
          default: {
            break;
          }
        }
      }
    });

    return `${configs.join(';')}||||${content.join('').trim()}`;
  }
};
const lineTypes = {
  FILE: 2,
  TEXT: 1,
};

export {
  configType,
  configutationsIds,
  possibleConfigurations,
  certStatus,
  ambits,
  proveedor,
  lineTypes,
  Configuration
};

//
